import * as React from 'react'
import { observer } from 'mobx-react'
import MilestonesViewModel from './MilestonesViewModel'
import { Section, SectionContent, SectionHeader } from 'components/Section'
import NoTasks from './NoTasks'
import TaskList from './TaskList'
import MilestoneCompletionModal from './MilestoneCompletionModal'
import styles from './Milestones.sass'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  vm: MilestonesViewModel
  isCardLayout?: boolean
}

export default observer(function Milestones({ vm, isCardLayout }: Props) {
  const lists = vm.taskLists.filter(
    (list) => list.tasks.length > 0 || list.isDesignee,
  )
  return (
    <>
      {lists.map((list) => (
        <Section
          collapsible
          key={list.designee}
          onToggleCollapse={() => list.toggleExpansion()}
          collapsed={!list.expanded}
        >
          <SectionHeader>
            <span className={styles.taskTitle}>{list.title}</span>
            {list.tasks.length === 0 ? (
              <span className={styles.taskCompletion}>(0)</span>
            ) : (
              <span className={styles.taskCompletion}>
                ({list.completedCount} of {list.tasks.length})
              </span>
            )}
          </SectionHeader>
          <SectionContent>
            {list.tasks.length > 0 ? (
              <TaskList isCardLayout={isCardLayout} list={list} />
            ) : (
              <NoTasks />
            )}
          </SectionContent>
        </Section>
      ))}
      <MilestoneCompletionModal vm={vm} isCardLayout={isCardLayout} />
    </>
  )
})
